import React, {Component} from "react";
import {connect} from "react-redux";
import CloseButton from "./CloseButton";
import * as platform from 'platform';
import jstz from 'jstz';

// Component Imports

// SASS Imports
require('./Modal.scss');
require('./AboutTimeTrackerModal.scss');

const mapStateToProps = (state, ownProps) => {
	return {
		settings: state.settings,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {};
};

class AboutTimeTrackerModal extends Component {
	constructor(props){
		super(props);
	}

	render() {
		const version = process.env.VERSION;
		const userAgent = platform.description;
		const locale = (navigator.language || navigator.browserLanguage).split('-')[0];
		const timezone = jstz.determine().name();

		return (
			<div className="modalPanel defaultModal">
				{this.props.closeModal?
					<button className="close" onClick={ this.props.closeModal }>
						<CloseButton />
					</button>:null}
				<div className="modalWrap">
					<div className="modalHeader text-center">
						<h4>About Time Tracker</h4>
					</div>

					<div className="modalContent">
						<div className="container-fluid">
							<div className="row">
								<div className="col-sm-1 col-xs-2">
									<h4>Version:</h4>
								</div>
								<div className="col-sm-6 col-xs-6 col-sm-offset-1">
									<h4>{ version }</h4>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-1 col-xs-2">
									<p>Browser:</p>
								</div>
								<div className="col-sm-6 col-xs-6 col-sm-offset-1">
									<p>{ userAgent }</p>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-1 col-xs-2">
									<p>Locale:</p>
								</div>
								<div className="col-sm-6 col-xs-6 col-sm-offset-1">
									<p>{ locale }</p>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-2 col-xs-2">
									<p>Time Zone:</p>
								</div>
								<div className="col-sm-6 col-xs-6">
									<p>{ timezone }</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutTimeTrackerModal);



// WEBPACK FOOTER //
// ./app/components/Modals/AboutTimeTrackerModal.jsx